module.exports = __webpack_public_path__ + "img/MEDIA116.4dfb60df.jpg";